// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-create-clip-welcome-modal.modal {
    align-items: flex-start;
}

.baloa-play-create-clip-welcome-modal .modal__container  {
    padding: 0;
    background: none;
    margin: unset;
    margin-top: 4vh;
}

.baloa-play-create-clip-welcome-modal__container {
    text-align: center;
}

.baloa-play-create-clip-welcome-modal__button {
    padding: 24px;
    border-radius: 6px;
    background: var(--primary-very-dark-color);
    margin: 20px 0;
}

.baloa-play-create-clip-welcome-modal__button .button {
    width: 100%;
    padding: 12px 24px;
}

.baloa-play-create-clip-welcome-modal__button .button .icon {
    grid-area: icon;
    margin-right: 8px;
}

.baloa-play-create-clip-welcome-modal__button .hubicon-video_library-1::before {
    color: var(--white-color);
}

.baloa-play-create-clip-welcome-modal__call-widget {
    /* visibility: hidden; */
    width: 400px;
    background-color: var(--white-color);
    color: var(--primary-very-dark-color);
    text-align: center;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    top: 100%;
    left: 50%;
    margin-left: -200px;
}

.baloa-play-create-clip-welcome-modal__call-widget::after {
    content: " ";
    position: absolute;
    bottom: 100%;  /* At the top of the tooltip */
    left: 50%;
    margin-left: -24px;
    border-width: 24px;
    border-style: solid;
    border-color: transparent transparent var(--white-color) transparent;
}

.baloa-play-create-clip-welcome-modal__call-widget__message {
    padding: 12px;
}

.baloa-play-create-clip-welcome-modal__call-widget__message .baloa-normal-medium {
    color: var(--primary-very-dark-color);
    text-align: center;
}

.baloa-play-create-clip-welcome-modal__call-widget__message .baloa-names {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    margin-top: 8px;
}

.baloa-play-create-clip-welcome-modal__call-widget__button {
    padding: 8px 16px;
    border-top: 1px solid var(--new-input-background-color);
    text-align: center;
}

.baloa-play-create-clip-welcome-modal__call-widget__button .button {
    margin-left: auto;
    margin-right: auto;
    padding: 8px 12px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-play-create-clip-welcome-modal__container {
        padding: 24px 24px 16px 24px;
    }

    .baloa-play-create-clip-welcome-modal__container .hubicon-award_star {
        font-size: 40px;
    }

    .baloa-play-create-clip-welcome-modal__title {
        font-size: 16px;
        margin-top: 12px;
    }


    .baloa-play-create-clip-welcome-modal__message {
        font-size: 14px;
        margin-top: 16px;
    }

    .baloa-play-create-clip-welcome-modal__container .button {
        font-size: 15px;
    }

    .baloa-play-create-clip-welcome-modal__call-widget {
        width: 260px;
        margin-left: -130px;
        border: 1px solid white;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-create-clip-welcome-modal-component/BaloaPlayCreateClipWelcomeModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,oCAAoC;IACpC,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY,GAAG,8BAA8B;IAC7C,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,oEAAoE;AACxE;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,uDAAuD;IACvD,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;;IAGA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;IAC3B;AACJ","sourcesContent":[".baloa-play-create-clip-welcome-modal.modal {\n    align-items: flex-start;\n}\n\n.baloa-play-create-clip-welcome-modal .modal__container  {\n    padding: 0;\n    background: none;\n    margin: unset;\n    margin-top: 4vh;\n}\n\n.baloa-play-create-clip-welcome-modal__container {\n    text-align: center;\n}\n\n.baloa-play-create-clip-welcome-modal__button {\n    padding: 24px;\n    border-radius: 6px;\n    background: var(--primary-very-dark-color);\n    margin: 20px 0;\n}\n\n.baloa-play-create-clip-welcome-modal__button .button {\n    width: 100%;\n    padding: 12px 24px;\n}\n\n.baloa-play-create-clip-welcome-modal__button .button .icon {\n    grid-area: icon;\n    margin-right: 8px;\n}\n\n.baloa-play-create-clip-welcome-modal__button .hubicon-video_library-1::before {\n    color: var(--white-color);\n}\n\n.baloa-play-create-clip-welcome-modal__call-widget {\n    /* visibility: hidden; */\n    width: 400px;\n    background-color: var(--white-color);\n    color: var(--primary-very-dark-color);\n    text-align: center;\n    border-radius: 6px;\n    position: absolute;\n    z-index: 1;\n    top: 100%;\n    left: 50%;\n    margin-left: -200px;\n}\n\n.baloa-play-create-clip-welcome-modal__call-widget::after {\n    content: \" \";\n    position: absolute;\n    bottom: 100%;  /* At the top of the tooltip */\n    left: 50%;\n    margin-left: -24px;\n    border-width: 24px;\n    border-style: solid;\n    border-color: transparent transparent var(--white-color) transparent;\n}\n\n.baloa-play-create-clip-welcome-modal__call-widget__message {\n    padding: 12px;\n}\n\n.baloa-play-create-clip-welcome-modal__call-widget__message .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n    text-align: center;\n}\n\n.baloa-play-create-clip-welcome-modal__call-widget__message .baloa-names {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    margin-top: 8px;\n}\n\n.baloa-play-create-clip-welcome-modal__call-widget__button {\n    padding: 8px 16px;\n    border-top: 1px solid var(--new-input-background-color);\n    text-align: center;\n}\n\n.baloa-play-create-clip-welcome-modal__call-widget__button .button {\n    margin-left: auto;\n    margin-right: auto;\n    padding: 8px 12px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-play-create-clip-welcome-modal__container {\n        padding: 24px 24px 16px 24px;\n    }\n\n    .baloa-play-create-clip-welcome-modal__container .hubicon-award_star {\n        font-size: 40px;\n    }\n\n    .baloa-play-create-clip-welcome-modal__title {\n        font-size: 16px;\n        margin-top: 12px;\n    }\n\n\n    .baloa-play-create-clip-welcome-modal__message {\n        font-size: 14px;\n        margin-top: 16px;\n    }\n\n    .baloa-play-create-clip-welcome-modal__container .button {\n        font-size: 15px;\n    }\n\n    .baloa-play-create-clip-welcome-modal__call-widget {\n        width: 260px;\n        margin-left: -130px;\n        border: 1px solid white;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
